export const FEEDBACK_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSeCXr6B3HAQ2rBcwaqPJfi3T-tgJohiMQibd_P-ify4H2K7DA/viewform?usp=sharing&ouid=111644023676671945766";
